var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconAlert40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Alert48",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Alert",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("g", {
    id: "Pictogram",
    transform: "translate(13.500000, 9.000000)",
    stroke: "#1E1E1E"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 7.875,
    y1: 31.875,
    x2: 8.60260688,
    y2: 28.9645725,
    id: "Line-2",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.875,
    y1: 29.625,
    x2: 7.37115088,
    y2: 27.9608994,
    id: "Line-2",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Bell"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-6",
    fill: "#FAEC20",
    cx: 10.475,
    cy: 25.1428571,
    rx: 2.6,
    ry: 2.64285714
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-6",
    fill: "#FFFFFF",
    cx: 10.575,
    cy: 2.35714286,
    rx: 1.95,
    ry: 1.98214286
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.76187478,25.125 C1.65451914,25.125 1.54786391,25.1077129 1.44600462,25.0738024 C0.921995512,24.8993522 0.638622081,24.333139 0.81307235,23.8091298 L0.81307235,23.8091298 L1.87311558,20.625 L1.87311558,20.625 L1.87311558,12.703125 C1.87311558,11.814354 2.13254307,10.2159699 2.52229899,9.421875 C3.87785121,6.66002205 6.68628442,4.5 10.5,4.5 L10.5,4.5 C14.3137156,4.5 17.1221488,6.66002205 18.477701,9.421875 C18.8674569,10.2159699 19.1268844,11.814354 19.1268844,12.703125 L19.1268844,20.625 L19.1268844,20.625 L20.1869276,23.8091298 C20.3613779,24.333139 20.0780045,24.8993522 19.5539954,25.0738024 C19.4521361,25.1077129 19.3454809,25.125 19.2381252,25.125 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconAlert40);
export default __webpack_public_path__ + "static/media/pictogramBeaconAlert40.4d75dac8e15c06eb30422968a15d6476.svg";
export { ForwardRef as ReactComponent };